import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';

@Injectable({
  providedIn: 'root',
})
export class ConnectionChangedService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  /**
   * This is the text shown in the automation editor.
   */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.CONNECTION_CHANGED.ACTION'),
      this.noValidationErrorsDetected(),
    );
  }

  /**
   * This is the text that appears in the activity column in the activity table.
   * Each column has a title (big text) and body (small text).
   * Most, but not all, trigger activity entries have "Entered the automation" (or similar) as the title
   * and then a custom body.
   */
  getActivityColumn(_namespace: string, _activity: ActivityInterface): ActivityTableEntry {
    return this.triggerActivityEntry(
      this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.CONNECTION_CHANGED.ACTIVITY'),
    );
  }
}
